<app-navbar></app-navbar>
<div class="main-layout">
  <aside class="left-aside">
    <app-ads-skyscraper position="left"></app-ads-skyscraper>
  </aside>


  <main class="main-content">
    <app-notifications></app-notifications>
    <router-outlet></router-outlet>
  </main>

  <aside class="right-aside">
    <app-ads-skyscraper position="right"></app-ads-skyscraper>
  </aside>
</div>
<app-footer></app-footer>
<app-popup></app-popup>
